import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

/**
 * Dispatch
 */
import PaperworkAnalyticsView from '../views/Paperwork/PaperworkAnalyticsView.vue';
import Error404 from '../components/Error404.vue';
import Forbidden from '../components/Forbidden.vue';
// import Calendar from '../views/Dispatch/DriverCalendar.vue';
import Schedule from '../views/Dispatch/Schedule.vue';
import TerminalAdvice from '../views/Dispatch/TerminalAdvice.vue';
import ProductCode from '../views/Dispatch/ProductCode.vue';
import dptReports from '../views/Dispatch/Report.vue';
import AudiLogs from '../views/Dispatch/AudiLogs.vue';
import Eleos from '../views/Dispatch/Eleos.vue';
import EleosCheck from '../views/Dispatch/EleosCheck.vue';
// import DispatchV2 from '../views/Dispatch/Dispatcfes.vue';
import DispatchSandbox from '../views/Dispatch/DispatchSandboxView.vue';
import InvoiceForm from '../views/Administration/InvoiceForm.vue';
import InvoiceRegular from '../views/Administration/InvoiceRegular.vue';

/**
 * Administration
 */
import FuelExpensesEntries from '../views/Administration/FuelExpensesEntriesView.vue';
import CheckStatements from '../views/Administration/CheckStatementsView.vue';
import FuelStatement from '../views/Administration/FuelStatementView.vue';
import ViewFuelStatement from '../views/Administration/ViewFuelStatementView.vue';
import PayrollHrly from '../views/Administration/PayrollHrly.vue';
import Payroll from '../views/Administration/Payroll.vue';
import PayrollView from '../views/Administration/PayrollView.vue';
import Search from '../views/Catalogs/Search.vue';
import DriversCredentials from '../views/Administration/DriversCredentials.vue';
import DriversCredentialsForm from '../views/Administration/DriversCredentialsForm.vue';
import ActivityLog from '../views/Audit/ActivityLogTable.vue';
import invoicesummaryReport from '../views/Reports/InvoiceSummaryReport.vue';
import ReportsGenerator from '../views/Reports/ReportGenerator.vue';
import DynamicReport from '../views/Reports/DynamicReport.vue';
import ReportExtExpense from '../views/Reports/ReportExtExpense.vue';
import ConfirmFuelStatement from '../views/Administration/ConfirmFuelStatement.vue';
import Analytics from '../views/Analytics/Analytics.vue';
import AnalyticsDetail from '../views/Analytics/ShiftAnalyticsDetails.vue';
import AnalyticsTransacting from '../views/Analytics/AnalyticsTransacting.vue';
import AnalyticsPosting from '../views/Analytics/AnalysisPosting.vue';
import DrillDownLevel from '../views/Analytics/DrillDownLevel.vue';
import ShiftExpensesRevenue from '../views/Analytics/ShiftExpensesRevenue.vue';
import DrillDownExpRev from '../views/Analytics/DrillDownExpRev.vue';
import LoadBy from '../views/Reports/LoadBy.vue';
import DRLoadBy from '../views/Reports/DRLoadBy.vue';
import DetailsBy from '../views/Reports/DetailsBy.vue';
import CircleK from '../views/Conciliation/CircleK.vue';
import Parkland from '../views/Conciliation/Parkland.vue';
import Main from '../views/KPIs/Customers/Main.vue';
import Deliveries from '../views/Administration/Deliveries.vue';

import Suncor from '../views/Conciliation/Suncor.vue';
import DocCategories from '../views/Catalogs/DocCategories.vue';
import OrderRequisition from '../views/ExternalUsers/Customers/OrderRequisition.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/customer/login',
        name: 'CustomerLogin',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/Logout.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/UserView',
        component: () => import('../views/UserView.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/',
                name: 'Default',
                component: () => import('../views/Home.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.home']
                }
            },
            {
                path: '/home',
                name: 'Home',
                component: () => import('../views/Home.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.home']
                }
            },
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('../views/Dashboard/Dashboard.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.dashboard']
                }
            },

            {
                path: '/dispatch',
                name: 'DispatchModule',
                component: () => import('../views/Main/Dispatch.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.dispatch']
                },
                children: [
                    {
                        path: 'sandbox',
                        name: 'DispatchSandbox',
                        component: DispatchSandbox
                    },
                    {
                        path: 'dispatch',
                        name: 'Dispatch',
                        component: () =>
                            import('../views/Dispatch/DispatchView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.dispatch']
                        }
                    },
                    {
                        path: 'carding',
                        name: 'carding',
                        component: () =>
                            import('../views/Dispatch/CardingView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.carding']
                        }
                    },
                    // {
                    //     path: 'travel-matrix',
                    //     name: 'travelMatrix',
                    //     component: () =>
                    //         import('../views/Dispatch/TravelMatrix.vue'),
                    //     meta: {
                    //         requiresAuth: true,
                    //         permissions: ['module.dispatch.travel-matrix']
                    //     }
                    // },
                    {
                        path: 'schedule',
                        name: 'Schedule',
                        component: () =>
                            import('../views/Dispatch/Schedule.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.schedule']
                        }
                    },
                    {
                        path: 'shift-assignment',
                        name: 'ShiftAssignment',
                        component: () =>
                            import('../views/Dispatch/ShiftAssignment.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.shift-assignment']
                        }
                    },
                    {
                        path: 'orders',
                        name: 'Orders',
                        component: () => import('../views/Dispatch/Order.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.orders']
                        }
                    },
                    {
                        path: 'orders/form',
                        name: 'OrdersForm',
                        component: () =>
                            import('../views/Dispatch/OrderForm.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.orders']
                        }
                    },
                    {
                        path: 'eleos',
                        name: 'Eleos',
                        component: () => import('../views/Dispatch/Eleos.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch']
                        }
                    },
                    {
                        path: 'eleos-check',
                        name: 'EleosCheck',
                        component: () =>
                            import('../views/Dispatch/EleosCheck.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch']
                        }
                    },
                    {
                        path: 'readings',
                        name: 'Readings',
                        component: () =>
                            import('../views/Dispatch/Readings.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.readings']
                        }
                    },
                    {
                        path: 'readings-v2',
                        name: 'ReadingsV2',
                        component: () =>
                            import('../views/Dispatch/ReadingsV2.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.readings-v2']
                        }
                    },
                    {
                        path: 'map',
                        name: 'MapDisplay',
                        component: () =>
                            import('../views/Dispatch/MapDisplay.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.map']
                        }
                    },
                    {
                        path: 'manual-readings',
                        name: 'ManualReadings',
                        component: () =>
                            import('../views/Dispatch/ManualReadings.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.manual-readings']
                        }
                    },
                    {
                        path: 'shift-logs',
                        name: 'AudiLogs',
                        component: () =>
                            import('../views/Dispatch/AudiLogs.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.shift-logs']
                        }
                    },
                    {
                        path: 'station-advice',
                        name: 'StationAdvice',
                        component: () =>
                            import('../views/Dispatch/StationAdvice.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.station-advice']
                        }
                    },
                    {
                        path: 'terminal-advice',
                        name: 'TerminalAdvice',
                        component: () =>
                            import('../views/Dispatch/TerminalAdvice.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.terminal-advice']
                        }
                    },
                    {
                        path: 'product-code',
                        name: 'ProductCode',
                        component: () =>
                            import('../views/Dispatch/ProductCode.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.product-code']
                        }
                    },
                    {
                        path: 'tracking',
                        name: 'Tracking',
                        component: () =>
                            import('../views/Dispatch/TrackingView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.tracking']
                        }
                    },
                    {
                        path: 'new-tracking',
                        name: 'NewTracking',
                        component: () =>
                            import('../views/Dispatch/NewTrackingView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.tracking']
                        }
                    },
                    {
                        path: 'event-history',
                        name: 'EventHistory',
                        component: () =>
                            import('../views/Dispatch/EventHistoryView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch']
                        }
                    },
                    {
                        path: 'bol-data-by-product',
                        name: 'BOLDataByProduct',
                        component: () =>
                            import(
                                '../views/Dispatch/BOLDataByProductView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.bol-data-by-product']
                        }
                    },
                    {
                        path: 'daily-dispatch-report',
                        name: 'dptReports',
                        component: () => import('../views/Dispatch/Report.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: [
                                'module.dispatch.daily-dispatch-report'
                            ]
                        }
                    },
                    {
                        path: 'reports',
                        name: 'Reports',
                        component: () => import('../views/Reports/Reports.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.reports']
                        }
                    },
                    // {
                    //     path: 'auto-dispatch',
                    //     name: 'Auto Dispatch',
                    //     component: () =>
                    //         import('../views/Dispatch/AutoDispatch.vue'),
                    //     meta: {
                    //         requiresAuth: true,
                    //         permissions: ['module.dispatch.dispatch']
                    //     }
                    // },
                    {
                        path: 'dispatch-v2',
                        name: 'DispatchV2',
                        component: () =>
                            import('../views/Dispatch/DispatchV2.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.dispatch']
                        }
                    },
                    {
                        path: 'dispatch-v3',
                        name: 'DispatchV3',
                        component: () =>
                            import('../views/Dispatch/DispatchV3.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.dispatch']
                        }
                    },
                    {
                        path: 'duration-calculation',
                        name: 'duration-calculation',
                        component: () =>
                            import('../views/Dispatch/DurationCalculation.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.dispatch']
                        }
                    },
                    {
                        path: 'average-station-tank-consumption',
                        name: 'average-station-tank-consumption',
                        component: () =>
                            import('../views/Dispatch/AverageStationTankConsumption.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.dispatch']
                        }
                    },
                    // {
                    //     path: 'dispatch-v2',
                    //     name: 'DispatchV2',
                    //     component: () =>
                    //         import('../views/Dispatch/Dispatch-V2.vue'),
                    //     meta: {
                    //         requiresAuth: true,
                    //         permissions: ['module.it']
                    //     }
                    // }
                    {
                        path: 'zone-durations',
                        name: 'ZoneDurations',
                        component: () => import('../views/Dispatch/ZoneDurations.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.dispatch.zone-durations']
                        }
                    },
                ]
            },
            {
                path: '/administration',
                name: 'AdministrationModule',
                component: () => import('../views/Main/Administration.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                },
                children: [
                    {
                        path: 'deliveries',
                        name: 'Deliveries',
                        component: () =>
                            import('../views/Administration/Deliveries.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.deliveries']
                        }
                    },
                    {
                        path: 'customer-kpis',
                        name: 'Customer KPIs',
                        component: () =>
                            import('../views/KPIs/Customers/Main.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.customer-kpis']
                        }
                    },
                    {
                        path: 'circle-k',
                        name: 'CircleK',
                        component: () =>
                            import('../views/Conciliation/CircleK.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system']
                        }
                    },
                    {
                        path: 'ck-edi',
                        name: 'CircleKEDIView',
                        component: () =>
                            import('../views/Administration/CKEDIView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'eleos-check',
                        name: 'EleosCheck',
                        component: () =>
                            import('../views/Dispatch/EleosCheck.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.eleos-check']
                        }
                    },
                    {
                        path: 'paperwork-analysis',
                        name: 'PaperworkAnalyticsView',
                        component: () =>
                            import(
                                '../views/Paperwork/PaperworkAnalyticsView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: [
                                'module.administration.paperwork-analysis'
                            ]
                        }
                    },
                    {
                        path: 'invoicing',
                        name: 'InvoiceForm',
                        component: () =>
                            import('../views/Administration/InvoiceForm.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.invoicing']
                        }
                    },
                    {
                        path: 'invoice-demurrage',
                        name: 'InvDemurrage',
                        component: () =>
                            import(
                                '../views/Administration/InvoiceDemurrage.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: [
                                'module.administration.invoice-demurrage'
                            ]
                        }
                    },
                    {
                        path: 'transacting',
                        name: 'Transacting',
                        component: () =>
                            import('../views/Administration/Transacting.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.transacting']
                        }
                    },
                    {
                        path: 'transacting-data-admin',
                        name: 'TransactingDataAdmin',
                        component: () =>
                            import(
                                '../views/Administration/TransactingDataAdmin.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.transacting']
                        }
                    },
                    {
                        path: 'transacting-data',
                        name: 'TransactingData',
                        component: () =>
                            import(
                                '../views/Administration/TransactingData.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.transacting']
                        }
                    },
                    {
                        path: 'transacting-data-finalized',
                        name: 'TransactingDataFinalized',
                        component: () =>
                            import(
                                '../views/Administration/TransactingDataFinalized.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.transacting']
                        }
                    },
                    {
                        path: 'new-transacting',
                        name: 'NewTransacting',
                        component: () =>
                            import(
                                '../views/Administration/NewTransacting.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: [
                                'module.administration.new-transacting'
                            ]
                        }
                    },
                    {
                        path: 'posting',
                        name: 'Posting',
                        component: () =>
                            import('../views/Administration/Posting.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.posting']
                        }
                    },
                    {
                        path: 'fuel',
                        name: 'Fuel',
                        component: () =>
                            import('../views/Administration/FuelView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.fuel']
                        }
                    },
                    {
                        path: 'fuel/expenses-entries',
                        name: 'FuelExpensesEntries',
                        component: () =>
                            import(
                                '../views/Administration/FuelExpensesEntriesView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.fuel']
                        }
                    },
                    {
                        path: 'fuel/check-statements',
                        name: 'CheckStatements',
                        component: () =>
                            import(
                                '../views/Administration/CheckStatementsView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.fuel']
                        }
                    },
                    {
                        path: 'fuel/fuel-statement',
                        name: 'FuelStatement',
                        component: () =>
                            import(
                                '../views/Administration/FuelStatementView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.fuel']
                        }
                    },
                    {
                        path: 'fuel/view-fuel-statement',
                        name: 'ViewFuelStatement',
                        component: () =>
                            import(
                                '../views/Administration/ViewFuelStatementView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.fuel']
                        }
                    },
                    {
                        path: 'payroll-hrly',
                        name: 'PayrollHrly',
                        component: () =>
                            import('../views/Administration/PayrollHrly.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.payroll-hrly']
                        }
                    },
                    {
                        path: 'payroll',
                        name: 'Payroll',
                        component: () =>
                            import('../views/Administration/Payroll.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.payroll']
                        }
                    },
                    {
                        path: 'payroll-view',
                        name: 'PayrollView',
                        component: () =>
                            import('../views/Administration/PayrollView.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.payroll']
                        }
                    },
                    {
                        path: 'missing-ppw-email',
                        name: 'MissingPPWEmail',
                        component: () =>
                            import('../views/Administration/MissingEmail.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'invoice-kms',
                        name: 'InvoiceKms',
                        component: () =>
                            import('../views/Administration/OriginInvoice.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration.invoice-kms']
                        }
                    },
                    {
                        path: 'invoice-search',
                        name: 'InvoiceSearch',
                        component: () =>
                            import(
                                '../views/Administration/InvoiceSearchKms.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'confirm-fuel-statement',
                        name: 'ConfirmFuelStatement',
                        component: () =>
                            import(
                                '../views/Administration/ConfirmFuelStatement.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'view-invoiceadm',
                        name: 'InvoiceRegular',
                        component: () =>
                            import(
                                '../views/Administration/InvoiceRegular.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'reports',
                        name: 'AdministrationReports',
                        component: () => import('../views/Reports/Reports.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'shift-logs',
                        name: 'AudiLogs',
                        component: () =>
                            import('../views/Dispatch/AudiLogs.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: '/administration/reconciliation',
                        name: 'ReconciliationView',
                        component: () =>
                            import(
                                '../views/Administration/ReconciliationView.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'runout-analysis',
                        name: 'RunoutAnalysis',
                        component: () =>
                            import(
                                '../views/Administration/RunoutAnalysis.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    },
                    {
                        path: 'readings-analysis',
                        name: 'ReadingsAnalysis',
                        component: () =>
                            import(
                                '../views/Administration/ReadingsAnalysis.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.administration']
                        }
                    }
                ]
            },
            {
                path: '/accounting',
                name: 'Accounting',
                component: () => import('../views/Main/Accounting.vue'),
                children: [
                    {
                        path: 'summary-report',
                        name: 'invoicesummaryReport',
                        component: () =>
                            import('../views/Reports/InvoiceSummaryReport.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.accounting']
                        }
                    },

                    {
                        path: 'shift-truck-usage',
                        name: 'KmHrsShifts',
                        component: () =>
                            import(
                                '../views/Accounting/ShiftTruckUsageReport.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.accounting']
                        }
                    },
                    {
                        path: 'ext-expense',
                        name: 'ReportExtExpense',
                        component: () =>
                            import('../views/Reports/ReportExtExpense.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.accounting']
                        }
                    },
                    {
                        path: 'mail',
                        name: 'Mail',
                        component: () => import('../views/Accounting/Mail.vue')
                    }
                ]
            },
            {
                path: '/hsse',
                name: 'SafetyModule',
                component: () => import('../views/Main/Safety.vue'),
                children: [
                    {
                        path: 'drivers-credentials',
                        name: 'DriversCredentials',
                        component: DriversCredentials,
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.safety']
                        }
                    },
                    {
                        path: 'drivers-credentials/form',
                        name: 'DriversCredentialsForm',
                        component: DriversCredentialsForm,
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.safety']
                        }
                    }
                ]
            },
            {
                path: '/maintenance',
                name: 'Maintenance',
                component: () => import('../views/Main/Maintenance.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.maintenance']
                },
                children: [
                    {
                        path: 'invoices',
                        name: 'MaintenanceInvoices',
                        component: () =>
                            import('../views/Maintenance/Invoices.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                    },
                    {
                        path: 'work-orders',
                        name: 'WorkOrders',
                        component: () => import('../components/Error404.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                        //import('../views/Maintenance/WorkOrders.vue')
                    },
                    {
                        path: 'work-orders/:id',
                        name: 'WorkOrderDetails',
                        component: () =>
                            import('../views/Maintenance/WorkOrderDetails.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                    },
                    {
                        path: 'purchase-orders',
                        name: 'PurchaseOrders',
                        component: () =>
                            import('../views/Maintenance/PurchaseOrders.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                    },
                    {
                        path: 'inventory',
                        name: 'Inventory',
                        component: () => import('../components/Error404.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                        //import('../views/Maintenance/Inventory.vue')
                    },
                    {
                        path: 'reports',
                        name: 'MaintenanceReports',
                        component: () =>
                            import('../views/Maintenance/Reports.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                    },
                    {
                        path: 'invoice-analysis',
                        name: 'InvoiceAnalysis',
                        component: () =>
                            import('../views/Maintenance/InvoiceAnalysis.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                    },
                    {
                        path: 'catalogs',
                        name: 'MaintenanceCatalogs',
                        component: () =>
                            import('../views/Maintenance/Catalogs.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.maintenance']
                        }
                    }
                ]
            },
            {
                path: '/hr',
                name: 'HRModule',
                component: () => import('../views/Main/HR.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.hr']
                },
                children: [
                    {
                        path: 'employees',
                        name: 'Employees',
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.hr']
                        }
                    },
                    {
                        path: 'employees/:id',
                        name: 'EmployeeDetails',
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.hr']
                        }
                    },
                    {
                        path: 'drivers-list',
                        name: 'DriversList',
                        component: () =>
                            import('../views/HumanResources/DriversList.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.hr']
                        }
                    },
                    {
                        path: 'reports',
                        name: 'HRReports',
                        component: () =>
                            import('../views/HumanResources/Reports.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.hr']
                        }
                    },
                    {
                        path: 'safety-meetings',
                        name: 'SafetyMeetings',
                        component: () =>
                            import(
                                '../views/HumanResources/SafetyMeetings.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.hr']
                        }
                    },
                    {
                        path: 'document-categories',
                        name: 'DocCategories',
                        component: DocCategories,
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.hr']
                        }
                    }
                ]
            },
            {
                path: '/system',
                name: 'SystemModule',
                component: () => import('../views/Main/System.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.system']
                },
                children: [
                    {
                        path: '/catalogs',
                        name: 'SystemCatalogs',
                        component: () =>
                            import('../views/Catalogs/Catalogs.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system']
                        },
                        children: [
                            {
                                path: 'book-off-causes',
                                name: 'BookOffCause',
                                component: () =>
                                    import(
                                        '../views/Catalogs/BookOffCause.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: ['module.system']
                                }
                            },
                            {
                                path: 'credetial-types',
                                name: 'CredentialType',
                                component: () =>
                                    import(
                                        '../views/Catalogs/CredentialType.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: ['module.system']
                                }
                            },
                            {
                                path: 'customers',
                                name: 'Customer',
                                component: () =>
                                    import('../views/Catalogs/Customer.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.customers'
                                    ]
                                }
                            },
                            {
                                path: 'customers/form',
                                name: 'CustomerForm',
                                component: () =>
                                    import(
                                        '../views/Catalogs/CustomerForm.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.customers'
                                    ]
                                }
                            },
                            {
                                path: 'drivers',
                                name: 'Driver',
                                component: () =>
                                    import('../views/Catalogs/Driver.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.drivers'
                                    ]
                                }
                            },
                            {
                                path: 'drivers/form',
                                name: 'DriverForm',
                                component: () =>
                                    import('../views/Catalogs/DriverForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.drivers'
                                    ]
                                }
                            },
                            {
                                path: 'eleos-actions',
                                name: 'EleosActions',
                                component: () =>
                                    import(
                                        '../views/Catalogs/EleosActions.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.eleos-actions'
                                    ]
                                }
                            },
                            {
                                path: 'eleos-actions/form',
                                name: 'EleosActionsForm',
                                component: () =>
                                    import(
                                        '../views/Catalogs/EleosActionsForm.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.eleos-actions'
                                    ]
                                }
                            },
                            {
                                path: 'no-load-types',
                                name: 'NoLoadType',
                                component: () =>
                                    import('../views/Catalogs/NoLoadType.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.noload-types'
                                    ]
                                }
                            },
                            {
                                path: 'order-type',
                                name: 'OrderType',
                                component: () =>
                                    import('../views/Catalogs/OrderType.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.order-types'
                                    ]
                                }
                            },
                            {
                                path: 'products',
                                name: 'Product',
                                component: () =>
                                    import('../views/Catalogs/Product.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.products'
                                    ]
                                }
                            },
                            {
                                path: 'products/form',
                                name: 'ProductForm',
                                component: () =>
                                    import('../views/Catalogs/ProductForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.products'
                                    ]
                                }
                            },
                            {
                                path: 'split-type',
                                name: 'SplitType',
                                component: () =>
                                    import('../views/Catalogs/SplitType.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.split-types'
                                    ]
                                }
                            },
                            {
                                path: 'stations',
                                name: 'Station',
                                component: () =>
                                    import('../components/Catalogs/Stations.vue'), // import('../views/Catalogs/Station.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.stations'
                                    ]
                                }
                            },
                            {
                                path: 'stations/form',
                                name: 'StationForm',
                                component: () =>
                                    import('../views/Catalogs/StationForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.stations'
                                    ]
                                }
                            },
                            {
                                path: 'station-rate',
                                name: 'StationRates',
                                component: () =>
                                    import(
                                        '../views/Administration/StationRates.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.station-rate'
                                    ]
                                }
                            },
                            {
                                path: 'suppliers',
                                name: 'Supplier',
                                component: () =>
                                    import('../views/Catalogs/Supplier.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.suppliers'
                                    ]
                                }
                            },
                            {
                                path: 'suppliers/form',
                                name: 'SupplierForm',
                                component: () =>
                                    import(
                                        '../views/Catalogs/SupplierForm.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.suppliers'
                                    ]
                                }
                            },
                            {
                                path: 'tanks',
                                name: 'Tank',
                                component: () =>
                                    import('../views/Catalogs/Tank.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.tanks'
                                    ]
                                }
                            },
                            {
                                path: 'tanks/form',
                                name: 'TankForm',
                                component: () =>
                                    import('../views/Catalogs/TankForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.tanks'
                                    ]
                                }
                            },
                            {
                                path: 'terminals',
                                name: 'Terminal',
                                component: () =>
                                    import('../views/Catalogs/Terminal.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.terminals'
                                    ]
                                }
                            },
                            {
                                path: 'terminals/form',
                                name: 'TerminalForm',
                                component: () =>
                                    import(
                                        '../views/Catalogs/TerminalForm.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.terminals'
                                    ]
                                }
                            },
                            {
                                path: 'terminals/yards',
                                name: 'TerminalYards',
                                component: () =>
                                    import(
                                        '../views/Catalogs/TerminalYards.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.terminals'
                                    ]
                                }
                            },
                            {
                                path: 'trailers',
                                name: 'Trailer',
                                component: () =>
                                    import('../views/Catalogs/Trailer.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.trailers'
                                    ]
                                }
                            },
                            {
                                path: 'trailers/form',
                                name: 'TrailerForm',
                                component: () =>
                                    import('../views/Catalogs/TrailerForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.trailers'
                                    ]
                                }
                            },
                            {
                                path: 'trucks',
                                name: 'Truck',
                                component: () =>
                                    import('../views/Catalogs/Truck.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.trucks'
                                    ]
                                }
                            },
                            {
                                path: 'trucks/form',
                                name: 'TruckForm',
                                component: () =>
                                    import('../views/Catalogs/TruckForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.trucks'
                                    ]
                                }
                            },
                            {
                                path: 'yards',
                                name: 'Yard',
                                component: () =>
                                    import('../views/Catalogs/Yard.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.yards'
                                    ]
                                }
                            },
                            {
                                path: 'yards/form',
                                name: 'YardForm',
                                component: () =>
                                    import('../views/Catalogs/YardForm.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.yards'
                                    ]
                                }
                            },
                            {
                                path: 'product-station-priv',
                                name: 'ProductStatioPriv',
                                component: () =>
                                    import(
                                        '../views/Catalogs/ProductStatioPriv.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.products-station-priv'
                                    ]
                                }
                            },
                            {
                                path: 'oo-companies',
                                name: 'OOCompanies',
                                component: () =>
                                    import('../views/Catalogs/OOCompanies.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.oo-companies'
                                    ]
                                }
                            },
                            {
                                path: 'invoice/group',
                                name: 'InvoiceGroup',
                                component: () =>
                                    import(
                                        '../views/Catalogs/InvoiceGroup.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.fsc-group-invoice'
                                    ]
                                }
                            },
                            {
                                path: 'grouping-rate',
                                name: 'GroupingRate',
                                component: () =>
                                    import(
                                        '../views/Catalogs/GroupingRate.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.grouping-rate'
                                    ]
                                }
                            },
                            {
                                path: 'customer/rates',
                                name: 'CustomerRates',
                                component: () =>
                                    import(
                                        '../views/Catalogs/CustomerRates.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.customer-rates'
                                    ]
                                }
                            },
                            {
                                path: 'unfinalized-cause',
                                name: 'UnfinalizedCause',
                                component: () =>
                                    import(
                                        '../views/Catalogs/UnfinalizedCause.vue'
                                    ),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.unfinalized-cause'
                                    ]
                                }
                            },
                            {
                                path: 'grouping-rate-ffb',
                                name: 'GroupingFFB',
                                component: () =>
                                    import('../views/Catalogs/GroupingFFB.vue'),
                                meta: {
                                    requiresAuth: true,
                                    permissions: [
                                        'module.system.catalogs.grouping-rate-ffb'
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: 'users',
                        name: 'ConfigurationUsers',
                        component: () => import('../views/System/Users.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system.users']
                        }
                    },
                    {
                        path: 'roles',
                        name: 'ConfigurationRoles',
                        component: () => import('../views/System/Roles.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system.roles']
                        }
                    },
                    {
                        path: 'permissions',
                        name: 'ConfigurationPermissions',
                        component: () =>
                            import('../views/System/Permissions.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system.permissions']
                        }
                    },
                    {
                        path: 'activity-log',
                        name: 'ConfigurationAudit',
                        component: () =>
                            import('../views/Audit/ActivityLogTable.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system.audit-logs']
                        }
                    },
                    {
                        path: 'system-log',
                        name: 'ConfigurationSystemLog',
                        component: () =>
                            import('../views/System/SystemLog.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.system.system-logs']
                        }
                    }
                ]
            },
            {
                path: '/it',
                name: 'ITModule',
                component: () => import('../views/Main/IT.vue'),
                children: [
                    {
                        path: 'Support',
                        name: 'Support',
                        component: () => import('../views/IT/Support.vue')
                    },
                    {
                        path: 'eleos-credentials',
                        name: 'EleosCredentials',
                        component: () =>
                            import('../views/IT/EleosCredentials.vue')
                    }
                ]
            },
            {
                path: '/advanced-analytics',
                name: 'AdvancedAnalyticsModule',
                component: () => import('../views/Main/AdvancedAnalytics.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.advanced-analytics']
                },
                children: [
                    {
                        path: 'chat',
                        name: 'Assistant',
                        component: () =>
                            import('../views/AdvancedAnalytics/Assistant.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.advanced-analytics']
                        }
                    },
                    {
                        path: 'income-statements',
                        name: 'IncomeStatements',
                        component: () =>
                            import(
                                '../views/AdvancedAnalytics/IncomeStatements.vue'
                            ),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.advanced-analytics']
                        }
                    },
                    {
                        path: 'map',
                        name: 'Map',
                        component: () =>
                            import('../views/AdvancedAnalytics/Map.vue'),
                        meta: {
                            requiresAuth: true,
                            permissions: ['module.advanced-analytics']
                        }
                    }
                ]
            },
            {
                path: '/paperwork-analytics',
                name: 'PaperworkAnalyticsView',
                component: PaperworkAnalyticsView,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/shift-analytics',
                name: 'Analytics',
                component: Analytics,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/shift-analytics-detail',
                name: 'AnalyticsDetail',
                component: AnalyticsDetail,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/shift-analytics/specific',
                name: 'DrillDownLevel',
                component: DrillDownLevel,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/shift-analytics/rev',
                name: 'DrillDownExpRev',
                component: DrillDownExpRev,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },

            {
                path: '/shift-analytics/expenses-or-revenues',
                name: 'ShiftExpensesRevenue',
                component: ShiftExpensesRevenue,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/shift-analytics/transacting',
                name: 'AnalyticsTransacting',
                component: AnalyticsTransacting,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/shift-analytics/posting',
                name: 'AnalyticsPosting',
                component: AnalyticsPosting,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/reports/report-generator',
                name: 'ReportsGenerator',
                component: ReportsGenerator,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/reports/loads-by',
                name: 'LoadBy',
                component: LoadBy,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/reports/report/load/by',
                name: 'DRLoadBy',
                component: DRLoadBy,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/reports/dynamic',
                name: 'DynamicReport',
                component: DynamicReport,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/reports/details/load/by',
                name: 'DetailsBy',
                component: DetailsBy,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/search',
                name: 'Search',
                component: Search,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.search']
                }
            },
            {
                path: '/conciliation/circle-k',
                name: 'CircleK',
                component: CircleK,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/conciliation/parkland',
                name: 'Parkland',
                component: Parkland,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },
            {
                path: '/conciliation/suncor',
                name: 'Suncor',
                component: Suncor,
                meta: {
                    requiresAuth: true,
                    permissions: ['module.administration']
                }
            },

            // Customers
            {
                path: '/customer/order-requisition',
                name: 'OrderRequisition',
                component: () => import('../views/ExternalUsers/Customers/OrderRequisition.vue'),
                meta: {
                    requiresAuth: true,
                    permissions: ['module.customer.order-requisition']
                },
                // children: [
                    
                // ]
            },
        ]
    },
    {
        path: '*',
        name: 'Error404',
        component: Error404
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        component: Forbidden
    }
];

const router = new VueRouter({
    mode: 'history',
    //base: process.env.VUE_APP_BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    // Set document title
    document.title = to.meta.title || 'UPT';

    // Check if the user is already authenticated via localStorage
    const token = localStorage.getItem('access_token');

    try {
        // If no token exists and the route requires authentication, redirect to login
        if (to.matched.some(record => record.meta.requiresAuth) && !token) {
            return next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                } // Save the intended route
            });
        }

        // If there's a token, ensure it's set in axios headers and Vuex state
        if (token && store.getters['auth/loadingAuth']) {
            await store.dispatch('auth/initializeAuth'); // Reinitialize auth state
        }

        // Esperar hasta que la autenticación esté completa si hay token pero aún se está cargando
        if (store.getters['auth/loadingApp']) {
            const unwatch = store.watch(
                (state, getters) => getters['auth/loadingApp'],
                (loadingApp) => {
                    if (!loadingApp) {
                        unwatch(); // Detener el watch cuando la carga termine
                        next(); // Continuar con la navegación
                    }
                }
            );
            return; // Detenemos la navegación mientras esperamos que se cargue la autenticación
        }

        // Check if the route requires specific permissions
        const requiredPermissions = to.meta.permissions || [];
        const userHasPermission = requiredPermissions.every(permission =>
            store.getters['permissions/hasPermission'](permission)
        );

        // If the user lacks the necessary permissions, redirect or show an error page
        if (requiredPermissions.length && !userHasPermission) {
            return next({
                name: 'Forbidden'
            });
        }

        // Proceed with navigation
        next();
    } catch (error) {
        console.error('Error in navigation guard:', error);
        next('/login'); // Redirect to login on error
    }
    // If there's a token, ensure it's set in axios headers and Vuex state
    if (token && !store.getters['auth/isLoggedIn']) {
        await store.dispatch('auth/initializeAuth'); // Reinitialize auth state
    }

    // Check if the route requires specific permissions
    const requiredPermissions = to.meta.permissions || [];
    const userHasPermission = requiredPermissions.every(permission =>
        store.getters['permissions/hasPermission'](permission)
    );

    // If the user lacks the necessary permissions, redirect or show an error page
    if (requiredPermissions.length && !userHasPermission) {
        return next({
            name: 'Error404'
        });
    }

    // Proceed with navigation
    next();
});

export default router;
